
import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/system/Box';
import { usePallet } from '../contexts/PalletContext';
import styled from "styled-components";
import useStyles from '../components/layout/Styles';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';

export interface IComboItem {
    value: string,
    label: string
}
interface IProps {
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: React.ReactNode,
    value?: string,
    focused?: boolean,
    className?: string,
    inputValue?: string,
    style?: React.CSSProperties,
    menuStyle?: React.CSSProperties,
    itens?: Array<string>,
    startAdornment?: React.ReactNode,
    clear?: boolean,
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
}

export default function ComboBoxBusca(props: IProps) {

    const classes = useStyles();
    const { pallet } = usePallet();
    const [value, setValue] = React.useState<string | null>(props.value || null);
    const [inputValue, setInputValue] = React.useState('');



    return (

            <div>

                        <TextField
                            fullWidth
                            label={props.label ? props.label : null}
                            placeholder={props.placeholder}
                            variant='outlined'
                            onChange={props.onChange}
                            InputProps={{
                                classes: {
                                    notchedOutline: classes.notchedOutline
                                },
                                style: {
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontSize: `${pallet.general.size14}`,
                                    fontWeight: pallet.general.weight_100,
                                    background: `${pallet.backgroundColorSecondary}`
                                },
                   
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {props.startAdornment ? props.startAdornment : <SearchIcon />}
                                    </InputAdornment>
                                )
                            }}
                        />

            </div>

    );
}